import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter, FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import { Icon } from '../../Defaults/Defaults';

interface Props {
  message: any;
  bottom?: string;
  right?: string;
  children?: any;
}

function Popup({ message, bottom, right, children }: Props) {
  return (
    <PopUpContainer
      bottom={bottom}
      right={right}
      show={message && message.length > 0}
    >
      <PopUpValidationMessage>{children || message}</PopUpValidationMessage>
      <ArrowIcon>
        <Icon src={'/assets/zemplin/arrow-triangle-gray.svg'} />
      </ArrowIcon>
    </PopUpContainer>
  );
}

const PopUpContainer: any = styled(FlexColCenter)<{
  bottom?: string;
  right?: string;
}>`
  position: absolute;
  bottom: ${({ bottom }) => (bottom ? bottom : '')};
  right: ${({ right }) => (right ? right : '')};
  color: #fff;
  opacity: ${(props: any) => (props.show ? 1 : 0)};
  transition: opacity 1s;
`;

const PopUpValidationMessage = styled(FlexRowCenter)`
  width: 100%;
  min-height: ${rem(35)};
  padding: ${rem(6)} ${rem(11)};
  background: rgb(0, 0, 0, 0.72);
  border-radius: ${rem(4)};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.primary};
`;

const ArrowIcon = styled(FlexRowCenter)`
  width: ${rem(15)};
  height: ${rem(15)};
  position: relative;
  bottom: ${rem(3.75)};
`;

export { Popup };
